import useOnContentEditHistoryUndoRedoChanged from './useOnContentEditHistoryUndoRedoChanged';

export default useOnContentEditHistoryUndoRedoChanged;